module.exports = require('./helpers/bundle-url').getBundleURL('ezjVb') + "logo-dark.eefe0b7f.svg";